import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
export const TagButtonListItem = (props) => {
    const { className = '', isActive = false, label, onClick: propsOnClick, value, } = props;
    /**
     * クリック時の処理
     * @description 引数にはボタンのvalueを渡す
     */
    const onClick = useCallback(() => {
        propsOnClick === null || propsOnClick === void 0 ? void 0 : propsOnClick(value);
    }, [propsOnClick, value]);
    return (_jsx("li", Object.assign({ className: className }, { children: _jsx("button", Object.assign({ className: clsx('inline-flex items-center justify-center', 'h-[39px]', 'p-12', 'rounded-[3px]', 'border border-solid', isActive
                ? ['bg-navy-100', 'border-navy-100']
                : ['bg-gray-50 hover:bg-gray-75', ' border-gray-100']), onClick: onClick, type: 'button' }, { children: _jsx(Text, Object.assign({ color: isActive ? 'white' : 'primary', size: 'sm' }, { children: label })) })) })));
};
